import React, { FC, useCallback, useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  ScrollArea,
  Spinner,
} from "@bandit-network/react-ui-kit";
import { LeaderBoardTable } from "../../components/LeaderBoardTable";
import { useQuestContext } from "../../context/QuestContext";
import { LeaderboardUser } from "@bandit-network/sdk-api";

interface LeaderBoardTypes {
  isOpen: boolean;
  onToggle: () => void;
}

const LIMIT = 10;

const LeaderBoard: FC<LeaderBoardTypes> = ({ isOpen, onToggle }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState<number>(0);
  const [totalResults, setTotalResults] = useState(0);
  const [leaderBoard, setLeaderboard] = useState<Array<LeaderboardUser>>([]);
  const { questSDK, quest } = useQuestContext();
  const getLeaderBoard = useCallback(async () => {
    try {
      setIsLoading(true);
      const offset = page * LIMIT;
      //TODO fix type
      //@ts-ignore
      const { data, totalResults, ...rest } =
        await questSDK.getCollectionLeaderboard(
          String(quest?.collectionId),
          LIMIT,
          offset,
        );
      setTotalResults(totalResults);
      setLeaderboard((state) => [...state, ...data]);
    } catch (e) {
    } finally {
      setIsLoading(false);
    }
  }, [page, quest, questSDK]);

  useEffect(() => {
    getLeaderBoard();
  }, [getLeaderBoard]);

  const nextPage = useCallback(() => {
    setPage((page) => page + 1);
  }, [setPage]);

  return (
    <Dialog open={isOpen} onOpenChange={onToggle}>
      <DialogContent
        onPointerDownOutside={(e) => e.preventDefault()}
        className="bad-quest__leaderboard--content"
      >
        <DialogHeader>
          <DialogTitle>{`Leaderboard`}</DialogTitle>
        </DialogHeader>
        {isLoading ? (
          <div className="bad-quest__leaderboard--loader">
            <Spinner />
          </div>
        ) : !!leaderBoard?.length ? (
          <ScrollArea className="bad-quest__leaderboard--scroll_area">
            <LeaderBoardTable leaderBoard={leaderBoard} />
          </ScrollArea>
        ) : (
          <div className="bad-quest__leaderboard--no_users">
            <p className="bad-quest__leaderboard--no_users_text">
              No Users Found
            </p>
          </div>
        )}
        {leaderBoard.length < totalResults && (
          <div className="bad-quest__leaderboard--footer">
            <Button
              variant="outline"
              size="sm"
              className="bad-quest__leaderboard--footer_button"
              onClick={nextPage}
            >
              Load more
            </Button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export { LeaderBoard };
